import { makeStyles } from "./index";

export default makeStyles()((theme) => ({
  close: {
    backgroundColor: "transparent",
    border: 0,
    right: 24,
    cursor: "pointer",
    padding: 0,
    position: "absolute",
    textAlign: "center",
    top: 20,
    "& svg": {
      height: 22,
      color: "#000",
    },
    "&:hover svg": {
      color: "#000",
    },
  },
  content: {
    padding: 0,
  },
  dialogActions: {
    paddingBottom: 24,
  },
  tableRowContent: {
    color: "#85858B",
    fontSize: "15px",
    "& td": {
      color: "#85858B",
      fontSize: "15px",
      padding: "12px 24px",
    },
  },
}));
